<template>
    <b-col cols="12" md="12" class="tab-content form-control p-3">
        <b-overlay :show="loading" rounded="sm">
            <b-form @submit.stop.prevent="onSubmit">
                <b-col cols="12">
                    <label class="mb-3"><strong>{{ title }} 2 {{  title == $translate('additional_field') ? '('+$translate('dropdown_label')+')': '' }}</strong></label>
                    <b-form-input type="text" class="form-control" id="addtional-field-2" v-model="model.label"
                        :placeholder="$translate('enter_name')" trim></b-form-input>
                </b-col>
                <b-col class="mt-3 text-right">
                    <b-button v-if="hasPermissionCreate && !model.id" block class="btn btn-info btn-fw" type="submit"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button v-if="hasPermissionUpdate && model.id" block class="btn btn-info btn-fw" type="submit"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                </b-col>
            </b-form>
        </b-overlay>
    </b-col>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'additionalFields-AdditionalFieldDropdown',
    mixins: [permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                label: null,
            },
            isModelSet: false,
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item', 'title'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */

        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id
        },
        /**
         * True if the user has permission to view but not update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return !!this.model.id
        },

        /**
         * True if the user has permission to update an request category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return !!this.model.id
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        cancelLabel() {
            if (this.canView) {
                return 'Back'
            } else {
                return 'Cancel'
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },

        additionalField2() {
            if (this.title == this.$translate('additional_field')) {
                return (
                    (this.$store.state.additionalField.additional_fields &&
                        this.$store.state.additionalField.additional_fields.find(
                            x => x.module_for == 1 && x.field_type === 2
                        )) ||
                    []
                )
            } else {
                return (
                    (this.$store.state.additionalField.additional_fields &&
                        this.$store.state.additionalField.additional_fields.find(
                            x => x.module_for == 2 && x.field_type === 2
                        )) ||
                    []
                )
            }
        },
    },
    // created() {
    //     if (this.title == this.$translate('additional_field')) {
    //         this.$store.dispatch('additionalField/fetchAll', { module_for: 1 })
    //     } else {
    //         this.$store.dispatch('additionalField/fetchAll', { module_for: 2 })
    //     }
    // },
    watch: {
        additionalField2: {
            handler: function (val) {
                this.model = val
            },
            deep: true,
        },
    },
    mounted() {
        if (this.item && this.item.id) {
            this.model = this.item
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            var defaultObj
            if (this.title == this.$translate('additional_field')) {
                defaultObj = {
                    module_for: 1,
                    field_type: 2,
                }
            } else {
                defaultObj = {
                    module_for: 2,
                    field_type: 2,
                }
            }
            const newModel = { ...this.model, ...defaultObj }
            const action = newModel.id ? 'update' : 'create'
            const path = `additionalField/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, newModel)
                        .then(() => {
                            this.loading = false
                            this.$emit(
                                'success',
                                `${action.charAt(0).toUpperCase() +
                                action.slice(1)
                                }d`
                            )
                        })
                        .catch(error => {
                            console.log('error', error)
                            this.$emit('error', error)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        deleteItem() {
            const model = { ...this.model }
            const path = 'additionalField/delete'
            // Generate and display confirmation prompt
            const title = `${this.$translate('delete')} ${this.$translate('additional_field_2')}?`
            const message = `${this.$translate('delete_note')} ${model.name}?`
            const errorMsg = this.$translate('unable_alert')
            this.$emit(
                'delete-item',
                title,
                message,
                model.id,
                () => {
                    this.$emit('success', this.$translate('deleted'))
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
